import { render, staticRenderFns } from "./EditStaticPage.vue?vue&type=template&id=1edaedb6"
import script from "./EditStaticPage.vue?vue&type=script&lang=ts"
export * from "./EditStaticPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports